import { render, staticRenderFns } from "./BaseRating.vue?vue&type=template&id=412ba9ed&functional=true&"
import script from "./BaseRating.vue?vue&type=script&lang=ts&"
export * from "./BaseRating.vue?vue&type=script&lang=ts&"
import style0 from "./BaseRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports